import { createFileRoute } from '@tanstack/react-router'

import { RoleGate } from '@/components/guards'
import { NotificationSettingsPage } from '@/pages/settings/organization/NotificationSettingsPage'

export const Route = createFileRoute(
  '/_authenticated/_dashboard/settings/organization/notifications/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <RoleGate requires="ADMIN">
      <NotificationSettingsPage />
    </RoleGate>
  )
}
